pageId = 'teams-external_apps-shimos-show'

$(document).on "pjaxload##{pageId}", ->
  $('#link-show-dialog').on 'click', ->
    simple.dialog
      content: $('#tpl-dialog-shimo-activation').html()
      cls: 'dialog-shimo-activation'
      buttons: null
      modal: true

